import React from 'react';
import { Check, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export function Offer() {
  return <div id="oferta" className="bg-cream" data-id="element-134">
      <Section className="max-w-4xl" data-id="element-135">
        <div className="bg-white rounded-3xl shadow-xl border border-beige-muted overflow-hidden" data-id="element-136">
          {/* Header */}
          <div className="bg-sage p-8 md:p-10 text-center" data-id="element-137">
            <h3 className="text-white font-bold text-2xl md:text-3xl font-playfair" data-id="element-138">
              Hoy tenés acceso completo a la guía y todos los bonos
            </h3>
          </div>

          {/* Body */}
          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-139">
            {/* Price Block */}
            <div className="mb-8" data-id="element-140">
              <p className="text-charcoal-light line-through text-xl mb-2" data-id="element-141">
                $39.980 ARS
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-142">
                <span className="bg-cta/10 text-cta font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wider" data-id="element-143">
                  50% OFF
                </span>
                <span className="text-5xl md:text-6xl font-playfair text-charcoal font-bold" data-id="element-144">
                  $19.990
                </span>
                <span className="text-charcoal-light font-medium text-lg" data-id="element-145">
                  ARS
                </span>
              </div>
            </div>

            {/* Includes */}
            <div className="space-y-4 mb-8 text-left w-full max-w-sm mx-auto" data-id="element-146">
              <div className="flex items-center gap-3" data-id="element-147">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-148" />
                <span className="text-charcoal font-medium" data-id="element-149">
                  Ebook completo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-150">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-151" />
                <span className="text-charcoal font-medium" data-id="element-152">
                  5 bonos GRATIS
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-153">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-154" />
                <span className="text-charcoal font-medium" data-id="element-155">
                  Acceso inmediato
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-156">
                <Check className="w-5 h-5 text-cta flex-shrink-0" data-id="element-157" />
                <span className="text-charcoal font-medium" data-id="element-158">
                  Descarga digital
                </span>
              </div>
            </div>

            {/* Payment Info */}
            <div className="flex flex-col items-center gap-3 mb-8 w-full max-w-sm mx-auto" data-id="element-159">
              <div className="flex items-center justify-center gap-3 bg-cream-dark border border-beige-muted/50 rounded-xl px-5 py-3 w-full" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/ur1Syj4W4XLkiMB7Qxx8Ae/descarga_(2).png" alt="Mercado Pago" className="h-7 w-auto object-contain" data-id="element-161" />
                <span className="text-charcoal-light text-sm font-medium" data-id="element-162">
                  💳 Pagá de forma segura con Mercado Pago
                </span>
              </div>
              <p className="text-charcoal font-medium text-sm" data-id="element-163">
                ✨ Hasta 3 cuotas sin interés
              </p>
            </div>

            {/* CTA */}
            <CTAButton className="w-full md:w-auto px-10 py-5 text-lg" data-id="element-164">
              QUIERO ACCESO INMEDIATO
            </CTAButton>
          </div>
        </div>
      </Section>
    </div>;
}